export const disableSearchOnPages = ['time', 'trash'];